const GROUP_ENQUIRY_TITLE = "Let's start designing the perfect Private Group Tour";
const GROUP_ENQUIRY_DESCRIPTION = `We're ready to help you build the perfect Private Group Tour for you and your clients.<br/>Share your vision, and we'll turn it into a reality.`;
const GROUP_ENQUIRY_DESTINATION_PLACEHOLDER = `Which countries would you like to include in your Private Group Tour?`;
const GROUP_ENQUIRY_GROUP_SIZE = `Estimated Group Size`;
const GROUP_ENQUIRY_GROUP_SIZE_TIP = `Please provide us with the estimated size of your group so we can build a realistic pricing structure.`;
const GROUP_ENQUIRY_TOUR_BRIEF_PLACEHOLDER = `Tell us about your ideal trip and provide as many details as possible. Share any special interests, must-see sights, and any other essential information we should know. Feel free to include links to examples or inspiration you've come across.`;

const META = {
    TITLE: "Design a Bespoke Trip with our Experts for Free | Designer Journeys",
    DESCRIPTION: "Trusted by over 1900 travellers, let our travel experts across 75 countries design your next trip for free.",
}
export {
    GROUP_ENQUIRY_TITLE,
    GROUP_ENQUIRY_DESCRIPTION,
    GROUP_ENQUIRY_DESTINATION_PLACEHOLDER,
    GROUP_ENQUIRY_GROUP_SIZE,
    GROUP_ENQUIRY_GROUP_SIZE_TIP,
    GROUP_ENQUIRY_TOUR_BRIEF_PLACEHOLDER,
    META,
};
